import React from 'react';
import moment from "moment";
//配置项

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "执行人",
    name: "fullName",
    dataIndex: "fullName",
    tableItem: {},
    searchItem: {},
  },
  {
    title: "账号",
    name: "userName",
    dataIndex: "userName",
    tableItem: {},
    searchItem: {},
  },
  {
    title: "执行状态",
    name: "executeState",
    dataIndex: "executeState",
    tableItem: {},
    formItem: {},
    dict: [
      {code: 0, codeName: "未开始"},
      {code: 1, codeName: "进行中"},
      {code: 2, codeName: "已完成"},
    ],
    searchItem: {
      type: "select",
    },
  },
  {
    title: "开始时间",
    name: "startDate",
    dataIndex: "startDate",
    tableItem: {},
  },
  {
    title: "结束时间",
    name: "endDate",
    dataIndex: "endDate",
    tableItem: {},
  },
  {
    title: "是否有效",
    name: "enableState",
    dataIndex: "enableState",
    tableItem: {},
    dict: [
      {code: 0, codeName: "无效"},
      {code: 1, codeName: "有效"},
    ],
    searchItem: {
      type: "select",
    },
  },
  {
    title: '执行时间',
    name: 'time',
    dataIndex: 'time',
    searchItem: {
      type: 'date~'
    }
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        dataFormat: (params) => {
          let value = Object.assign({}, params)
          if (value.time && value.time.length === 2) {
            value.startDate = moment(value.time[0]).format('YYYY-MM-DD HH:mm:ss')
            value.endDate = moment(value.time[1]).format('YYYY-MM-DD HH:mm:ss')
          }
          // delete value.time
          return value
        },
        buttonSort: ['export'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: {icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          },
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },

      rowOperateSort: [],
      rowOperateView: []
    }
  }
};

let getTypeValue = (type, value) => {
  const map = {
    "importance": [
      "重要",
      "一般",
      "证书"
    ],
    "limitCycleType": [
      "年",
      "月",
      "周",
      "日",
    ],
    "bizType": [
      "课程",
      "考试",
      "问卷",
      "直播",
      "考试模版组",
      "考试分类",
      "题目分类",
      "课件",
      "线下课程",
      "培训中心",
      "教室",
      "路径",
      "路径必修",
      "路径选修",
      "审核",
      "岗位能力考核项目",
      "报名",
      "评语",
      "栏目应用",
      "TMS远程认证",
      "内容通知",
      "证书管理",
      "话题",
      "活动",
      "帖子",
      "系列化课程",
      "互动直播",
      "推荐",
      "学分",
      "规则"
    ]
  }
  return map[type][value]
}

export {templateConfig, getTypeValue};
